import { HeadTagsConfig } from '@tenants/types/tenant';
import { LOCALE_EXP_IN_SERVICE_PATHS } from 'types/locales';

export function createHeadTagsConfig(): HeadTagsConfig {
  return {
    defaultTitle: 'eXp Realty® In Service',
    defaultMetaDescriptionKey: LOCALE_EXP_IN_SERVICE_PATHS.HEAD_TAGS_DEFAULT_META_DESCRIPTION,
  };
}

